import {ScreensEnum} from '../libs/enums';

    // Shared state of the chat app
export default function AppStore(agentData, tourData, socialMediaPostData, browserData) {

        const state = {
            activeScreen: ScreensEnum.chatButton,
            activeChat: false,
            messages: [],
            user: {
                email: '',
                phone: '',
                name: ''
            },
            agent: agentData,
            tour: tourData,
            socialMediaPost: socialMediaPostData,
            browser: browserData
        };

        const mutations = {
            addMessage: function (message) {
                state.messages.push(message);
            },
            nextScreen: function (screen) {
                state.activeScreen = screen;
            },
            setActiveChat: function (val) {
                state.activeChat = val;
            },
            setUser: function (user) {
                state.user = _.assign({}, state.user, user);
            },
            resetChat: function () {
                state.messages = [];
                state.activeChat = false;
                state.activeScreen = ScreensEnum.chatButton;
            }
        };

        return {
            state: state,
            mutations: mutations
        }
    };
